/**
 * Do not edit directly, use `yarn generate:icons`
 */

import React from 'react';
import {Base} from '../../../Internal/Base';

const pathStrings = {
  24: [
    'M3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0m9-11C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1M9 8a1 1 0 0 0 0 2h.01a1 1 0 0 0 0-2zm6 0a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2zm-7.6 5.2a1 1 0 0 1 1.397.196l.005.006.033.041q.05.061.16.178c.148.153.37.362.656.57.577.42 1.375.81 2.35.81.974 0 1.771-.39 2.348-.81a5 5 0 0 0 .816-.748l.034-.041.004-.006A1 1 0 0 1 16.8 14.6L16 14l.799.601-.001.002-.003.004-.007.009-.021.027-.07.086q-.089.107-.248.276a7 7 0 0 1-.923.804c-.798.58-2 1.191-3.526 1.191s-2.728-.61-3.526-1.191a7 7 0 0 1-1.17-1.08l-.07-.086-.022-.027-.007-.01-.003-.003V14.6H7.2a1 1 0 0 1 .2-1.4',
  ],
};

type Props = {size: keyof typeof pathStrings} & Omit<
  React.SVGAttributes<HTMLOrSVGElement>,
  'width' | 'height' | 'viewBox'
>;

export const IconHappy = ({
  size,
  className,
  ...rest
}: Props): React.ReactElement<React.ReactSVGElement> => {
  const paths = pathStrings[size].map((d: string, i: number) => (
    <path key={String(i)} d={d} fillRule="evenodd" />
  ));

  return (
    <Base
      as="svg"
      height={size}
      width={size}
      viewBox={`0 0 ${size} ${size}`}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      // Because viewPort(height + width) and viewBox might not have the same ratio
      // `preserveAspectRatio` indicates wether we should force a uniform scaling.
      // Therefore, `xMidYMid` centers the viewBox region within the viewPort region,
      // and `meet` scales the graphic until it meets the height and width of our viewPort.
      // More details here, https://www.digitalocean.com/community/tutorials/svg-preserve-aspect-ratio
      preserveAspectRatio="xMidYMid meet"
      fill="currentColor"
      {...rest}
    >
      {paths}
    </Base>
  );
};

IconHappy.displayName = 'IconHappy';
